import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Users from './views/Users.vue'
import Products from './views/Products.vue'
import Reports from './views/Reports.vue'
import Breakage from './views/Breakage.vue'
import Settings from './views/Settings.vue'
import ChangePassword from './views/ChangePassword.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import MissingMapping from './views/MissingMapping.vue'
import ImportHistory from './views/ImportHistory.vue'
import ManualTransactions from './views/ManualTransactions.vue'
import Saldo from './views/Saldo.vue'
import Mail from './views/Mail.vue'
import store from './store'

// import ChangePasswordModal from '@/components/ChangePasswordModal.vue'
// import { ModalProgrammatic } from 'buefy'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPassword
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: ChangePassword,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { requiresAuth: true }
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      meta: { requiresAuth: true }
    },
    {
      path: '/reports/:reportType',
      name: 'reports',
      component: Reports,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/saldo',
      name: 'saldo',
      component: Saldo,
      meta: { requiresAuth: true }
    },
    {
      path: '/manualtransactions',
      name: 'manualtransactions',
      component: ManualTransactions,
      meta: { requiresAuth: true }
    },
    {
      path: '/breakage',
      name: 'breakage',
      component: Breakage,
      meta: { requiresAuth: true }
    },
    {
      path: '/mail',
      name: 'mail',
      component: Mail,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: { requiresAuth: true }
    },
    {
      path: '/missingmapping/:reportType',
      name: 'missingmapping',
      component: MissingMapping,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/history',
      name: 'history',
      component: ImportHistory,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // console.log(`Er autentisert: ${JSON.stringify(store.state.auth.authenticated)}`)
  
  if (to.meta && to.meta.requiresAuth) {
    if (store.state.auth.authenticated)
      next()
    else
      router.push({
        path: '/',
        query: {
          showLogin: true
        }
      })
  }
  else {
    next()
  }
  
})


export default router;
